<div class="reset-card">
  <p>
    Please enter the <strong>email address</strong> where the new client secret should be sent. <br><br> <strong>Please
    note:</strong> Resetting the OAuth secret is <strong>permanent</strong> and <strong>cannot be undone</strong>.
  </p>
  <form (ngSubmit)="submit()" #clientSecretResetForm="ngForm" class="p-fluid reset-form" id="clientSecretResetForm">
    <div class="p-field p-float-label reset-field">
      <label class="label" for="input-email">Email Address:</label> <input pInputText
      id="input-email"
      type="email"
      name="email"
      [(ngModel)]="email"
      required
      email
      aria-label="Email"
      autocomplete="email"
      autocapitalize="off"
      #emailInput="ngModel"/>

    @if (emailInput.touched && emailInput.invalid) {
      <div class="error-messages" role="alert">
        @if (emailInput.errors?.required) {
          <div class="error-text">Email is required.</div>
        }
        @if (emailInput.errors?.email) {
          <div class="error-text">Please enter a valid email address.</div>
        }
      </div>
    }
  </div>
</form>

<p-footer>
  <div class="button-group">
    <button pButton
      type="submit"
      form="clientSecretResetForm"
      severity="primary"
      [disabled]="clientSecretResetForm.invalid"
      class="mr-2 submit-button">
      <i pButtonIcon class="pi pi-check"></i>
      <span pButtonLabel>Submit</span>
    </button>

    <button pButton type="button" severity="secondary" class="cancel-button" (click)="cancel()">
      <i pButtonIcon class="pi pi-times"></i>
      <span pButtonLabel>Cancel</span>
    </button>
  </div>
</p-footer>
</div>